export enum OnboardingStep {
  ProfilePicture = "ProfilePicture",
  BankAccount = "BankAccount",
  Calendar = "Calendar",
  Offering = "Offering",
  KycVerification = "KycVerification",
}

export interface ProfileStatusProps {
  profilePictureUploaded: boolean;
  bankAccountConnected: boolean;
  calendarConnected: boolean;
  hasOffering: boolean;
  kycVerified: boolean;
}

export class ProfileStatus {
  private readonly props: ProfileStatusProps;

  private constructor(props: ProfileStatusProps) {
    this.props = props;
  }

  static create(props: ProfileStatusProps): ProfileStatus {
    return new ProfileStatus(props);
  }

  get profilePictureUploaded(): boolean {
    return this.props.profilePictureUploaded;
  }

  get bankAccountConnected(): boolean {
    return this.props.bankAccountConnected;
  }

  get calendarConnected(): boolean {
    return this.props.calendarConnected;
  }

  get hasOffering(): boolean {
    return this.props.hasOffering;
  }

  get kycVerified(): boolean {
    return this.props.kycVerified;
  }

  isOnboardingComplete(): boolean {
    return this.incompleteSteps().length === 0;
  }

  incompleteSteps(): OnboardingStep[] {
    return this.orderedSteps()
      .filter(([, done]) => !done)
      .map(([step]) => step);
  }

  nextIncompleteStep(): OnboardingStep | undefined {
    return this.incompleteSteps()[0];
  }

  completedStepCount(): number {
    return this.orderedSteps().filter(([, done]) => done).length;
  }

  totalStepCount(): number {
    return this.orderedSteps().length;
  }

  private orderedSteps(): Array<[OnboardingStep, boolean]> {
    return [
      [OnboardingStep.ProfilePicture, this.props.profilePictureUploaded],
      [OnboardingStep.BankAccount, this.props.bankAccountConnected],
      [OnboardingStep.Calendar, this.props.calendarConnected],
      [OnboardingStep.Offering, this.props.hasOffering],
      [OnboardingStep.KycVerification, this.props.kycVerified],
    ];
  }
}
